import React from 'react';
import Billboard from './components/billboard/Billboard';
import Dash from './components/globals/Dash';
import Footer from './components/globals/Footer';
import NavBar from './components/globals/NavBar';

const App = () => (<div className="App">
  <Billboard />
  <NavBar />
  <Dash />
  
</div>);

export default App
